const INCH_IN_CM = 2.54
const CM_IN_FT = 30.48

const cmToFtIn = (cm = 0) => {
  const totalInch = cm / INCH_IN_CM
  const feet = Math.floor(totalInch / 12)
  const inch = totalInch - 12 * feet

  return { heightFt: Math.round(feet), heightIn: Math.round(inch) }
}

const ftInToCm = (ft = 0, inch = 0) => {
  const heightCm = Math.round(ft * CM_IN_FT + inch * INCH_IN_CM)

  return heightCm
}

export default (commonView) =>
  ({ nextStepPath, formFields }) => ({
    ...commonView({
      nextStepPath,
      formFields,
    }),

    init() {
      this.commonInit()
    },

    handleUnitsChange(units) {
      this.setMeasurementSystem(units)
      this.convertHeight()
      this.setSubmitAllowed(this.formValues, formFields)
    },

    handleHeightInput($event, field) {

      if (field === "heightIn") {
        const getSanitizedInValue = (val) => {
          // Specific validation limitation from product - 
          // we cant allow more than 11 inches
          if (val === "1" || val === "10" || val === "11") {
            return val
          }

          // If starts with 1 but followed by something else - correct to "11" or "1"
          if (val.startsWith("1")) {
            return "11".startsWith(val) ? val : "1"
          }

          // Get only first character
          val = val.slice(0, 1)
          return val
        }
        
        const sanitizedVal = getSanitizedInValue($event.target.value)
        $event.target.value = sanitizedVal
      }

      this.handleNumericInput($event, field)
      this.convertHeight()

      // Product requirement to auto-change focus for inches
      if ($event.target.value && field === "heightFt") {
        const heightInInput = document.getElementById("heightIn")

        setTimeout(() => {
          heightInInput.focus()
        }, 0)
      }
    },

    convertHeight() {
      if (this.isMetric()) {
        // Don't do anything if there is nothing to convert
        // to prevent invalid values to appear
        if (!this.formValues.heightCm && this.formValues.heightCm !== 0) return

        const { heightFt, heightIn } = cmToFtIn(this.formValues.heightCm)

        this.formValues.heightFt = heightFt

        // Specific validation limitation from product - 
        // we cant allow more than 11 inches
        this.formValues.heightIn = heightIn >= 11 ? 11 : heightIn
      }

      if (this.isImperial()) {
        const { heightFt, heightIn } = this.formValues

        const heightCm = ftInToCm(heightFt, heightIn)

        this.formValues.heightCm = heightCm
      }
    },

    // Perform final convertions before submit
    processFormValues() {
      const { heightCm, heightFt, heightIn } = this.formValues

      if (this.isMetric()) {
        return {
          heightCm,
          ...cmToFtIn(heightCm),
        }
      }

      if (this.isImperial()) {
        return {
          heightCm: ftInToCm(heightFt, heightIn),
          heightFt,
          heightIn,
        }
      }
    },

    setSubmitAllowed(formValues, formFields) {
      const requiredFields =
        this.store.values.measurementSystem === "imperial" ? ["heightFt", "heightIn"] : ["heightCm"]

      const allRequiredPresent = requiredFields.every((value) => {
        const formValue = formValues[value]

        if (Array.isArray(formValue)) return !!formValue.length

        return formValue || formValue === 0
      })

      this.isSubmitAllowed = allRequiredPresent

      // Reset validation errors on units change to not confuse user
      // because we perform validation only on form submit
      formFields.forEach((field) => (this.errors[field] = null))
    },
  })
